import React, { useEffect } from "react";
import DecorationBackground from "../../../login/components/DecorationBackground";

import logoIcon from "../../assets/logo-ux-white.svg";
import computerUxIcon from "../../assets/computerUx.svg";
import uxDecoration from "../../assets/decoration-uxdoc.svg";

import {
  Container,
  ContentMobile,
  DecorationWrapper,
  Description
} from "./styles";
import { ContractAnimation } from "../../../../shared/components/ContractAnimation";

const MobileScreen: React.FC = () => {
  const [loading, setLoading] = React.useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  if (loading) {
    return (
      <ContentMobile>
        <ContractAnimation />
      </ContentMobile>
    );
  }

  return (
    <Container>
      <DecorationWrapper>
        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transform: "translateX(10px)"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>

        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: "0.4"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>

        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: "0.4"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>

        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: "0.4"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>

        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transform: "translateX(90px)",
            opacity: "0.5"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>

        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: "0.5"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>

        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transform: "translateX(40px)",
            opacity: "0.6"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>

        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transform: "translateX(10px)",
            opacity: "0.7"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>

        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transform: "translateX(40px)",
            opacity: "0.75"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>

        <div
          style={{
            background: "transparent",
            width: "100%",
            height: "10%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transform: "translateX(90px)",
            opacity: "0.8"
          }}
        >
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
          <img style={{ marginRight: "17px" }} src={uxDecoration} />
        </div>
      </DecorationWrapper>

      <img className="logoUx" src={logoIcon} />

      <img className="computerUx" src={computerUxIcon} />

      <Description>
        Acesse o UX DOC <br /> a partir de um dispositivo desktop e comece a
        criar agora!
      </Description>
    </Container>
  );
};

export default MobileScreen;
